import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
export function MechanismSection() {
  const steps = [{
    number: '1',
    title: 'Herramienta',
    description: 'Una sola herramienta de IA'
  }, {
    number: '2',
    title: 'Problema',
    description: 'Un problema específico de PYMES'
  }, {
    number: '3',
    title: 'Flujo de $$$',
    description: 'Un flujo constante de dólares'
  }];
  return <section className="w-full bg-gradient-to-b from-slate-900 to-slate-800 py-20 px-4" data-id="element-35">
      <div className="max-w-6xl mx-auto" data-id="element-36">
        <motion.div className="text-center mb-16" initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} data-id="element-37">
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold mb-4" data-id="element-38">
            El Framework de{' '}
            <span className="text-gold-400" data-id="element-39">Especialización Flash</span>
          </h2>
          <p className="text-xl md:text-2xl text-teal-400 font-semibold" data-id="element-40">
            Dominar 1 micro-servicio en 48 horas
          </p>
        </motion.div>

        <motion.p className="text-xl md:text-2xl text-gray-200 text-center max-w-4xl mx-auto mb-16 leading-relaxed" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} data-id="element-41">
          Mi sistema corta el{' '}
          <span className="text-gold-400 font-semibold" data-id="element-42">
            99% del ruido tecnológico
          </span>
          . Te doy las{' '}
          <span className="text-teal-400 font-semibold" data-id="element-43">
            3 herramientas exactas
          </span>{' '}
          que funcionan en el mercado latino y el{' '}
          <span className="text-gold-400 font-semibold" data-id="element-44">guión de cierre</span>{' '}
          para que te digan "sí" antes de que termines la demo.
        </motion.p>

        {/* Visual Flow */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 items-center" data-id="element-45">
          {steps.map((step, index) => <motion.div key={step.number} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.6,
          delay: 0.1 * index
        }} className="relative" data-id="element-46">
              <div className="bg-slate-700 border-2 border-teal-500/50 rounded-xl p-8 text-center" data-id="element-47">
                <div className="w-16 h-16 bg-gold-400 text-slate-900 rounded-full flex items-center justify-center text-3xl font-heading font-bold mx-auto mb-4" data-id="element-48">
                  {step.number}
                </div>
                <h3 className="font-heading text-2xl font-bold text-gold-400 mb-2" data-id="element-49">
                  {step.title}
                </h3>
                <p className="text-gray-300" data-id="element-50">{step.description}</p>
              </div>

              {/* Arrow between steps */}
              {index < steps.length - 1 && <div className="hidden md:block absolute top-1/2 -right-3 transform -translate-y-1/2 z-10" data-id="element-51">
                  <ArrowRightIcon className="w-6 h-6 text-teal-400" data-id="element-52" />
                </div>}
            </motion.div>)}
        </div>
      </div>
    </section>;
}